module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9c1.c352b227.svg";